


















































































import Glide, { Controls } from '@glidejs/glide/dist/glide.modular.esm';
import {
  computed,
  defineComponent,
  nextTick,
  onBeforeUnmount, onMounted,
  onUpdated, PropType,
  ref,
  toRefs,
  watch,
} from '@nuxtjs/composition-api';

import { SimpleImage } from '~/components/common/SimpleImage';
import SimpleVideo from '~/components/common/SimpleVideo/SimpleVideo.vue';
import isServer from '~/helpers/isServer';

import { CarouselOptions } from '../types';

const ZOOM_DEFAULT_SIZE = {
  width: 600,
  height: 600,
};

export default defineComponent({
  name: 'Carousel',
  components: { SimpleVideo, SimpleImage },
  props: {
    options: {
      type: Object as PropType<CarouselOptions>,
      default: () => ({
        type: 'slider',
        autoplay: false,
        rewind: false,
        perView: 1,
        dragThreshold: 0,
      }),
    },
    activeIndex: {
      type: Number,
      default: 0,
    },
    images: {
      type: Array as PropType<object[]>,
      required: true,
    },
    hideImageAtIndex: {
      type: Number,
      default: null,
    },
    isZoom: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['loaded', 'goAction', 'videoStarted', 'toggle'],
  setup(props, { emit }) {
    const {
      options, activeIndex, isZoom,
    } = toRefs(props);

    let carousel = null;
    const carouselRef = ref();

    const sliderOptions = computed(() => ({ ...options.value, startAt: activeIndex.value }));
    const classSuffix = computed(() => (isZoom.value ? 'Zoom' : ''));
    const zoomContainerSize = computed(() => {
      if (isServer) {
        return ZOOM_DEFAULT_SIZE;
      }

      return {
        width: global.innerWidth,
        height: global.innerHeight,
      };
    });

    const goTo = (index: number = 0) => {
      if (!carousel) return;

      const nextIndex = index ?? activeIndex.value;

      carousel.go(`=${nextIndex}`);

      emit('goAction', nextIndex);
    };

    const openOverlay = () => {
      emit('toggle', { currentSlide: activeIndex.value, currentPage: 0 });
    };

    watch(activeIndex, goTo);

    onMounted(() => {
      emit('loaded');

      nextTick(() => {
        if (props.images.length === 0) {
          return;
        }

        const glide = new Glide(carouselRef.value, sliderOptions.value);

        glide.on('run', () => {
          goTo(+glide.index);
        });

        glide.mount({ Controls });
        carousel = glide;
      });
    });

    onUpdated(() => {
      if (carousel) {
        nextTick(() => {
          carousel.mount({ Controls });
        });
      }
    });

    onBeforeUnmount(() => {
      carousel?.destroy();
    });

    return {
      carouselRef,
      classSuffix,
      zoomContainerSize,
      openOverlay,
    };
  },
});
